// Framework and third-party non-ui
import React, { Component, Fragment } from 'react';
import moment from 'moment';
import Button from '@mui/material/Button';
// Redux operations and local helpers/utils/modules
import {getIncidentStatus} from '../../utils/incidentHelper';
import originFields from '../../defaults/PointOfOriginFields.json';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import TextField from 'material-ui/TextField';
import { getFieldAliasOverrides } from '../../utils/incidentHelper';


// JSON

// CSS
const styles = {
  checkbox: {
    marginBottom: 16,
  },
  textField: {
    width: '100%'
  }
};

class ReportMapSection extends Component {

    getCertTable = () => {
    const {certFields} = originFields.reportInfoFields;

    let statusVal = getIncidentStatus(this.props.selectedIncident.incident);
    
    const certifierBlock =
    this.props.certifierInfo ?
    (<Fragment>
      <TableRow>
        <TableRowColumn className="report-table-fieldname">Certifier Name</TableRowColumn>
        <TableRowColumn className="report-table-fieldvalue">{this.props.certifierInfo.fullName}
        </TableRowColumn>
      </TableRow>
  
      <TableRow>
        <TableRowColumn className="report-table-fieldname">Certifier Description</TableRowColumn>
        <TableRowColumn className="report-table-fieldvalue">{this.props.certifierInfo.description}</TableRowColumn>
      </TableRow>
  
      <TableRow>
        <TableRowColumn className="report-table-fieldname">Certifier Email</TableRowColumn>
        <TableRowColumn className="report-table-fieldvalue">{this.props.certifierInfo.email}
        </TableRowColumn>
      </TableRow>
  </Fragment>
    ) : "";
    
    return (
      <div>
        <Table
          selectable={false}
        >
          <TableBody
            displayRowCheckbox={false}
          >
          <TableRow key='ADSPermissionState'>
            <TableRowColumn className="report-table-fieldname">Status</TableRowColumn>
            <TableRowColumn className="report-table-fieldvalue">{statusVal}</TableRowColumn>
          </TableRow>
            {certFields.map(fieldName => {
              const fieldInfo = this.props.fieldInfos.find(info => info.name === fieldName);
              const fieldAlias = getFieldAliasOverrides(fieldInfo);
              //const fieldAlias = fieldInfo && fieldInfo.alias ? fieldInfo.alias : fieldName;

              let fieldValue = this.props.selectedIncident.incident.attributes[fieldName];
              if( fieldValue && (originFields.dateFieldsWithTypeDouble.includes(fieldName) || fieldInfo.type === "date")){
                fieldValue = moment(fieldValue).format(this.props.dateFormat);
              }

              return (
                <TableRow key={fieldName}>
                  <TableRowColumn className="report-table-fieldname">{fieldAlias.replace('POO ', '')}</TableRowColumn>
                  <TableRowColumn className="report-table-fieldvalue">{fieldValue}</TableRowColumn>
                </TableRow>
              );
            })
          }
          {certifierBlock}
          </TableBody>
        </Table>
      </div>
    )
  }

  showRecords = () => 
  {
    this.props.showRelatedRecords();
  }
  getRelatedRecordsTable = () => {
    const tableRows = []
  
    if (this.props.relatedRecords !== null && this.props.relatedRecords !== undefined)
    {
      const hasFireStatIncidents = this.props.relatedRecords.FireStatIncidents.length > 0;
      const hasIrwinIncidents = this.props.relatedRecords.IrwinIncidents.length > 0;
      const hasBulkUploadIncidents = this.props.relatedRecords.BulkUploadIncidents.length > 0;
      const hasWFMIIncidents =this.props.relatedRecords.WFMIIncidents.length > 0;
      const hasFODIncidents = this.props.relatedRecords.FODIncidents.length > 0;
      const hasCertificationRecords = this.props.relatedRecords.CertificationRecords.length > 0;
      const hasMergedRecords = this.props.relatedRecords.MergedRecords.length > 0;
      const mergeIds = (hasMergedRecords) ? this.props.relatedRecords.MergedRecords.map(mergeRecord => mergeRecord.UniqueFireIdentifier) : [];
      
      if (hasIrwinIncidents)
      {
        for (var i = 0; i < this.props.relatedRecords.IrwinIncidents.length; i++)
        {
          const ufi = this.props.relatedRecords.IrwinIncidents[i].UniqueFireIdentifier;
          const hasMatchingMerge = (hasMergedRecords) && mergeIds.includes(ufi);
          const matchingMergeRecord = (hasMatchingMerge) ? this.props.relatedRecords.MergedRecords.filter(record => record.UniqueFireIdentifier === ufi) : {}; 
          const isPrimary = this.props.relatedRecords.IrwinIncidents[i].IncidentID === this.props.relatedRecords.PrimarySourceID;
          const irwinRow = (
              <TableRow key={this.props.relatedRecords.IrwinIncidents[i].IrwinID}>
              <TableRowColumn className="report-table-fieldname">Related IRWIN Record</TableRowColumn>
              <TableRowColumn>
                <Table size="small" selectable={false}>
                <TableBody displayRowCheckbox={false}>
                  <TableRow>
                    <TableRowColumn>Irwin ID</TableRowColumn>
                    <TableRowColumn>
                      <Button variant="text" size='small' onClick={(e) => this.showRecords()}>{this.props.relatedRecords.IrwinIncidents[i].IrwinID}</Button>
                      </TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>Unique Fire Identifier</TableRowColumn>
                    <TableRowColumn>{this.props.relatedRecords.IrwinIncidents[i].UniqueFireIdentifier}</TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn >Incident Name</TableRowColumn>
                    <TableRowColumn>{this.props.relatedRecords.IrwinIncidents[i].IncidentName}</TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn >Created On</TableRowColumn>
                    <TableRowColumn>{moment(this.props.relatedRecords.IrwinIncidents[i].CreatedOnDateTime).format("MM/DD/YYYY h:mm A")}</TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>Created By System</TableRowColumn>
                    <TableRowColumn>{this.props.relatedRecords.IrwinIncidents[i].CreatedBySystem}</TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>Is Valid</TableRowColumn>
                    <TableRowColumn>{(this.props.relatedRecords.IrwinIncidents[i].IsValid) === 1 ? "Yes" : "No"}</TableRowColumn>
                  </TableRow>
                {isPrimary &&
                 <Fragment><TableRow>
                    <TableRowColumn>Is Primary</TableRowColumn>
                    <TableRowColumn>Yes</TableRowColumn>
                  </TableRow>
                </Fragment>
                }
                  {hasMatchingMerge &&
                 <Fragment><TableRow>
                    <TableRowColumn>Is Merged</TableRowColumn>
                    <TableRowColumn>Yes</TableRowColumn>
                  </TableRow>
                  <TableRow>
                  <TableRowColumn>Merged On</TableRowColumn>
                  <TableRowColumn>{moment(matchingMergeRecord[0].MergedOnDateTime).format("MM/DD/YYYY h:mm A")}</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Size at Merge</TableRowColumn>
                  <TableRowColumn>{matchingMergeRecord[0].IncidentSize}</TableRowColumn>
                </TableRow>
                </Fragment>
                }
                </TableBody>
                </Table>
                </TableRowColumn>
                </TableRow> 
            
          );
          tableRows.push(irwinRow);
        }
      }
  
      if (hasFireStatIncidents)
      {
        for (var j = 0; j < this.props.relatedRecords.FireStatIncidents.length; j++)
        {
          const fireStatRow = (
            <TableRow key={this.props.relatedRecords.FireStatIncidents[j].FireID}>
              <TableRowColumn className="report-table-fieldname">Related FireStat ID:</TableRowColumn>
              <TableRowColumn className="report-table-fieldvalue"><Button variant="text" onClick={() => this.showRecords()}>{this.props.relatedRecords.FireStatIncidents[j].FireID}</Button></TableRowColumn>
            </TableRow>
          );
          tableRows.push(fireStatRow);
        }
      }
  
      if (hasBulkUploadIncidents)
      {
        for (var k = 0; k < this.props.relatedRecords.BulkUploadIncidents.length; k++)
        {
          const bulkUploadRow = (
            <TableRow key={this.props.relatedRecords.BulkUploadIncidents[k].BulkUploadID}>
              <TableRowColumn className="report-table-fieldname">Related Bulk Upload ID:</TableRowColumn>
              <TableRowColumn className="report-table-fieldvalue"><Button variant="text" onClick={() => this.showRecords()}>{this.props.relatedRecords.BulkUploadIncidents[k].BulkUploadID}</Button></TableRowColumn>
            </TableRow>
          );
          tableRows.push(bulkUploadRow);
        }
      }
  
      if (hasWFMIIncidents)
      {
        for (var l = 0; l < this.props.relatedRecords.WFMIIncidents.length; l++)
        {
          const wfmiRow = (
            <TableRow key={this.props.relatedRecords.WFMIIncidents[l].FireId}>
              <TableRowColumn className="report-table-fieldname">Related WFMI ID:</TableRowColumn>
              <TableRowColumn className="report-table-fieldvalue"><Button variant="text" onClick={() => this.showRecords()}>{this.props.relatedRecords.WFMIIncidents[l].FireId}</Button></TableRowColumn>
            </TableRow>
          );
          tableRows.push(wfmiRow);
        }
      }
  
      if (hasFODIncidents)
      {
        for (var m = 0; m < this.props.relatedRecords.FODIncidents.length; m++)
        {
          const fodRow = (
            <TableRow key={this.props.relatedRecords.FODIncidents[m].FOD_ID}>
              <TableRowColumn className="report-table-fieldname">Related FOD ID:</TableRowColumn>
              <TableRowColumn className="report-table-fieldvalue"><Button variant="text" onClick={() => this.showRecords()}>{this.props.relatedRecords.FODIncidents[m].FOD_ID}</Button></TableRowColumn>
            </TableRow>
          );
          tableRows.push(fodRow);
        }
      }
  
      if (hasCertificationRecords)
      {
        for (var n = 0; n < this.props.relatedRecords.CertificationRecords.length; n++)
        {
          const certRow = (
            <TableRow key={this.props.relatedRecords.CertificationRecords[n].FOD_ID}>
              <TableRowColumn className="report-table-fieldname">Previous Certification ID:</TableRowColumn>
              <TableRowColumn className="report-table-fieldvalue"><Button variant="text" onClick={() => this.showRecords()}>{this.props.relatedRecords.CertificationRecords[n].CertificationRecordID}</Button></TableRowColumn>
            </TableRow>
          );
          tableRows.push(certRow);
        }
      }
    }
    
    return (
      <div className="report-table">
        <Table selectable={false}>
          <TableBody displayRowCheckbox={false}>
            {tableRows}
          </TableBody>
        </Table>
      </div>
    )
  }
  render() {

  const mapImage =
  this.props.screenshot && this.props.screenshot.url  ?
  (
    <div className="report-map-container">
      <img src={this.props.screenshot.url} alt="Map"  />
    </div>
  ) : "";



  return (
    <div className="report-map-section">
      {mapImage}
      <div className="narrative-container">
        <div className="report-map-narrative">
          <h3>Narrative</h3>
          <p>{this.props.selectedIncident.incident.attributes[originFields.report]}</p>
        </div>
      </div>
      <div className="report-map-cert-approval">
        <div className="cert-table">
          <h3>Certification</h3>
          {this.getCertTable()}
        </div>
        <div className="approval-container">
          <h3>Approval</h3>
          <div className="approval-fields">
            <TextField
              name="signature"
              floatingLabelText="Approver Signature"
              floatingLabelFixed={true}
              disabled={true}
              value=""
              style={styles.textField}
            />
            <TextField
              name="signature1"
              value=""
              disabled={true}
              style={styles.textField}
            />
            <TextField
              name="signature2"
              value=""
              disabled={true}
              style={styles.textField}
            />
            <TextField
              name="signature3"
              value=""
              disabled={true}
              style={styles.textField}
            />
            <TextField
              name="signature4"
              value=""
              disabled={true}
              style={styles.textField}
            />
            <TextField
              name="signature"
              floatingLabelText="Date Approved"
              floatingLabelFixed={true}
              disabled={true}
              value=""
              style={styles.textField}
            />
          </div>
        </div>
      </div>
      <div className="report-table-section">
                <h3>Related Records</h3>
                {this.getRelatedRecordsTable()}
              </div>
      <p className="section-footer">*Note: Specific approval and record management requirements are defined by the jurisdictional agency at Point of Origin</p>
    </div>
  );
}
}

ReportMapSection.propTypes = {};

ReportMapSection.defaultProps = {};

export default ReportMapSection;

